import { gql } from '@apollo/client';

export const STRIPE_CONNECT_CONNECTED_ACCOUNT = gql`
  mutation stripeCreateConnectedAccount($data: StripeCreateAccountInput!) {
    stripeCreateConnectedAccount(data: $data) {
      account {
        id
        chargesEnabled
        payoutsEnabled
        defaultAccount {
          id
          last4
          bankName
          currency
        }
      }
      onboarding {
        url
      }
    }
  }
`;
